import React from 'react';

const RANK_META = {
  Beginner: { badge: '🌱', color: 'from-zinc-500 to-zinc-600', text: 'text-zinc-200', ring: 'border-zinc-500/40' },
  Novice:   { badge: '📘', color: 'from-blue-500 to-sky-600',  text: 'text-sky-200',  ring: 'border-sky-500/40' },
  Trader:   { badge: '📈', color: 'from-emerald-500 to-green-600', text: 'text-emerald-200', ring: 'border-emerald-500/40' },
  Investor: { badge: '💼', color: 'from-purple-500 to-fuchsia-600', text: 'text-purple-200', ring: 'border-purple-500/40' },
  Pro:      { badge: '⚡', color: 'from-orange-500 to-red-600', text: 'text-orange-200', ring: 'border-orange-500/40' },
  Master:   { badge: '👑', color: 'from-yellow-400 to-yellow-600', text: 'text-black', ring: 'border-yellow-400/60' },
};

export const getRankMeta = (rank) => RANK_META[rank] || RANK_META.Beginner;

const RankBadge = ({ rank = 'Beginner', xp = null, size = 'md', showXp = false, testId }) => {
  const meta = getRankMeta(rank);
  const sizeCls = size === 'sm'
    ? 'text-[11px] px-2 py-0.5 gap-1'
    : size === 'lg'
      ? 'text-sm px-3 py-1.5 gap-1.5'
      : 'text-xs px-2.5 py-1 gap-1';

  return (
    <span
      data-testid={testId || `rank-badge-${rank.toLowerCase()}`}
      className={`inline-flex items-center ${sizeCls} rounded-full bg-gradient-to-r ${meta.color} ${meta.text} font-bold border ${meta.ring} whitespace-nowrap`}
    >
      <span>{meta.badge}</span>
      <span>{rank}</span>
      {showXp && xp !== null && <span className="opacity-80 font-mono">· {xp} XP</span>}
    </span>
  );
};

export default RankBadge;
